import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';

@Injectable({ providedIn: 'root' })
export class LoginRedirectGuard implements CanActivate {

  async canActivate() {
    if (Capacitor.getPlatform() === 'ios') {
    let tenant = localStorage.getItem('tenant');
    await Browser.open({
        url: 'https://main.church-services.org/'+ tenant +'/login'
    });
      return false; // stop Angular navigation
    }
    return true;
  }
} 
 